"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphalendClient = void 0;
exports.alphalendLoopingDeposit = alphalendLoopingDeposit;
exports.alphalendLoopingWithdraw = alphalendLoopingWithdraw;
exports.alphalendSuiStsuiLoopDepositTx = alphalendSuiStsuiLoopDepositTx;
exports.alphalendSingleLoopDeposit = alphalendSingleLoopDeposit;
exports.alphalendSuiStsuiLoopWithdrawTx = alphalendSuiStsuiLoopWithdrawTx;
exports.alphalendSingleLoopWithdraw = alphalendSingleLoopWithdraw;
const transactions_1 = require("@mysten/sui/transactions");
const index_js_1 = require("../index.js");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
const bluefin_js_1 = require("./bluefin.js");
async function alphalendLoopingDeposit(poolName, amount, options) {
    let txb = new transactions_1.Transaction();
    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
        txb = await alphalendSuiStsuiLoopDepositTx(amount, options);
    }
    return txb;
}
async function alphalendLoopingWithdraw(poolName, xTokens, options) {
    let txb = new transactions_1.Transaction();
    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
        txb = await alphalendSuiStsuiLoopWithdrawTx(xTokens, options);
    }
    return txb;
}
exports.alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, index_js_1.getSuiClient)());
async function alphalendSuiStsuiLoopDepositTx(amount, options) {
    const C = (0, index_js_1.getConf)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const poolName = "ALPHALEND-LOOP-SUI-STSUI";
    const poolData = index_js_1.poolInfo[poolName];
    await exports.alphalendClient.updatePrices(txb, [
        index_js_1.coinsList["STSUI"].type,
        "0x2::sui::SUI",
    ]);
    const receipt = await (0, index_js_1.getReceipts)(poolName, address, true);
    let someReceipt;
    if (receipt.length == 0) {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::none`,
            typeArguments: [poolData.receiptType],
            arguments: [],
        });
    }
    else {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::some`,
            typeArguments: [receipt[0].content.type],
            arguments: [txb.object(receipt[0].objectId)],
        });
    }
    const [depositCoin] = txb.splitCoins(txb.gas, [amount]);
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_one_swap`,
        typeArguments: [index_js_1.coinsList["ALPHA"].type],
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(index_js_1.bluefinPoolMap[`ALPHA-STSUI`]),
            txb.object(C.BLUEFIN_GLOBAL_CONFIG),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_no_swap_v2`,
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_two_swaps_v2`,
        typeArguments: [index_js_1.coinsList["BLUE"].type],
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.LST_INFO),
            txb.object(C.SUI_SYSTEM_STATE),
            txb.object(index_js_1.cetusPoolMap[`BLUE-SUI`]),
            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::user_deposit_v3`,
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(C.VERSION),
            someReceipt,
            txb.object(poolData.poolId),
            depositCoin,
            txb.object(poolData.investorId),
            txb.object(C.ALPHA_DISTRIBUTOR),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.LST_INFO),
            txb.object(C.SUI_SYSTEM_STATE),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    return txb;
}
async function alphalendSingleLoopDeposit(poolName, amount, options) {
    const C = (0, index_js_1.getConf)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const poolData = index_js_1.poolInfo[poolName];
    const coinName = index_js_1.loopingPoolCoinMap[poolName].supplyCoin;
    await exports.alphalendClient.updatePrices(txb, [index_js_1.coinsList[coinName].type]);
    const receipt = await (0, index_js_1.getReceipts)(poolName, address, true);
    let someReceipt;
    if (receipt.length == 0) {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::none`,
            typeArguments: [poolData.receiptType],
            arguments: [],
        });
    }
    else {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::some`,
            typeArguments: [receipt[0].content.type],
            arguments: [txb.object(receipt[0].objectId)],
        });
    }
    let totalCoin;
    if (coinName === "SUI") {
        totalCoin = txb.gas;
    }
    else {
        totalCoin = await (0, bluefin_js_1.getCoinObject)(index_js_1.coinsList[coinName].type, address, txb);
    }
    const [depositCoin] = txb.splitCoins(totalCoin, [amount]);
    await (0, index_js_1.collectAndSwapRewardsSingleLoop)(poolName, txb);
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::user_deposit`,
        typeArguments: [index_js_1.coinsList[coinName].type],
        arguments: [
            txb.object(C.ALPHA_ALPHALEND_VERSION),
            txb.object(C.VERSION),
            someReceipt,
            txb.object(poolData.poolId),
            depositCoin,
            txb.object(poolData.investorId),
            txb.object(C.ALPHA_DISTRIBUTOR),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.transferObjects([totalCoin], address);
    return txb;
}
async function alphalendSuiStsuiLoopWithdrawTx(xTokens, options) {
    const C = (0, index_js_1.getConf)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const poolName = "ALPHALEND-LOOP-SUI-STSUI";
    const poolData = index_js_1.poolInfo[poolName];
    const receipt = await (0, index_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, index_js_1.getReceipts)("ALPHA", address, true);
    await exports.alphalendClient.updatePrices(txb, [
        index_js_1.coinsList["STSUI"].type,
        "0x2::sui::SUI",
    ]);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_one_swap`,
            typeArguments: [index_js_1.coinsList["ALPHA"].type],
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`ALPHA-STSUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_no_swap_v2`,
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_two_swaps_v2`,
            typeArguments: [index_js_1.coinsList["BLUE"].type],
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.LST_INFO),
                txb.object(C.SUI_SYSTEM_STATE),
                txb.object(index_js_1.cetusPoolMap[`BLUE-SUI`]),
                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        const [stsui_coin] = txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::user_withdraw_v3`,
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(C.VERSION),
                txb.object(receipt[0].objectId),
                alpha_receipt,
                txb.object(C.ALPHA_POOL),
                txb.object(poolData.poolId),
                txb.pure.u64(xTokens),
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.LST_INFO),
                txb.object(C.SUI_SYSTEM_STATE),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `0x2::transfer::public_transfer`,
            typeArguments: [`0x2::coin::Coin<${index_js_1.coinsList["SUI"].type}>`],
            arguments: [stsui_coin, txb.pure.address(address)],
        });
    }
    else {
        throw new Error(`No ALPHALEND-LOOP-SUI-STSUI Receipt`);
    }
    return txb;
}
async function alphalendSingleLoopWithdraw(poolName, xTokens, options) {
    const C = (0, index_js_1.getConf)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const poolData = index_js_1.poolInfo[poolName];
    const receipt = await (0, index_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, index_js_1.getReceipts)("ALPHA", address, true);
    const coinName = index_js_1.loopingPoolCoinMap[poolName].supplyCoin;
    await exports.alphalendClient.updatePrices(txb, [index_js_1.coinsList[coinName].type]);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        await (0, index_js_1.collectAndSwapRewardsSingleLoop)(poolName, txb);
        const [coin] = txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::user_withdraw`,
            typeArguments: [index_js_1.coinsList[coinName].type],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(C.VERSION),
                txb.object(receipt[0].objectId),
                alpha_receipt,
                txb.object(C.ALPHA_POOL),
                txb.object(poolData.poolId),
                txb.pure.u64(xTokens),
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.transferObjects([coin], address);
    }
    else {
        throw new Error(`No ALPHALEND-LOOP-SUI-STSUI Receipt`);
    }
    return txb;
}
//# sourceMappingURL=alphalend.js.map